import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { getLocales } from 'assets/locales/Locale';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import AccountReceivableEvidenceSources from 'models/enums/AccountReceivableEvidenceSource';
import PaymentType from 'models/enums/PaymentType';
import { useAccountReceivableProvider } from '../Finance.AccountReceivable.Hooks';
import { cleanValues } from 'assets/utils/data/Object';

export default function FinanceAccountReceivableFilters() {
  const { lang, translate } = getLocales();
  const { listApi, dealerListApi, statementListApi, userListApi, pageRouter, allStatusesWithoutProcessed } =
    useAccountReceivableProvider();

  return (
    <div>
      <FilterForm
        subcomponents={ThemeFilterFormDrawer}
        onSortById={(sort) =>
          pageRouter.updateQuery({
            ...pageRouter.query,
            list: cleanValues({
              ...pageRouter.query?.list,
              ...sort,
            }),
          })
        }
        search={listApi.body?.search}
        onSearch={(search) =>
          pageRouter.updateQuery({
            ...pageRouter.query,
            list: cleanValues({
              ...pageRouter.query?.list,
              search,
              offset: 0,
            }),
          })
        }
        filters={listApi.body}
        onFilter={(newFilters) =>
          pageRouter.redirect(
            { ...pageRouter.params, action: undefined },
            {
              ...pageRouter.query,
              list: {
                ...newFilters,
                offset: 0,
              },
            }
          )
        }
        onReset={() => {
          pageRouter.redirect(
            { ...pageRouter.params, action: undefined },
            {
              ...pageRouter.query,
              list: undefined,
            }
          );
        }}
        onOpen={() => {
          if (!dealerListApi.payload) dealerListApi.execute((body) => body);
          if (!userListApi.payload) userListApi.execute((body) => body);
        }}
        render={({ tempFilters, setFilters }) => (
          <>
            <SelectInput
              name="dealerId"
              label={lang.dealer}
              data={dealerListApi.payload?.data?.map((item) => item.displayInfo) ?? []}
              isMultiselect
              value={tempFilters?.dealerId}
              onChange={({ dealerId }) => setFilters({ ...tempFilters, dealerId })}
              icon={<Icon class="fas-store" />}
            />
            <SelectInput
              name="statementId"
              label={lang.statement}
              data={statementListApi.payload?.data?.map((item) => item.displayInfo) ?? []}
              isMultiselect
              value={tempFilters?.statementId}
              onChange={({ statementId }) => setFilters({ ...tempFilters, statementId })}
              icon={<Icon class="fas-file" />}
            />
            <SelectInput
              name="createdById"
              label={lang.user}
              data={userListApi.payload?.data?.map((item) => item.displayInfo) ?? []}
              isMultiselect
              value={tempFilters?.createdById}
              onChange={({ createdById }) => setFilters({ ...tempFilters, createdById })}
              icon={<Icon class="fas-user" />}
            />
            <SelectInput
              name="evidenceSource"
              label={lang.evidenceSource}
              data={Object.values(AccountReceivableEvidenceSources).map((it) => ({
                id: it,
                title: translate(it),
                icon: <Icon class="fas-file-alt" />,
              }))}
              isMultiselect
              value={tempFilters?.evidenceSource}
              onChange={({ evidenceSource }) => setFilters({ ...tempFilters, evidenceSource })}
              icon={<Icon class="fas-file-alt" />}
            />
            <SelectInput
              name="statusCode"
              label={lang.status}
              data={Object.values(allStatusesWithoutProcessed).map((it) => ({
                id: it,
                title: translate(it),
                icon: <Icon class="fas-file-alt" />,
              }))}
              isMultiselect
              value={tempFilters?.statusCode}
              onChange={({ statusCode }) => setFilters({ ...tempFilters, statusCode })}
              icon={<Icon class="fas-file-alt" />}
            />
            <SelectInput
              name="paymentMethodCode"
              label={lang.paymentMethod}
              data={Object.values(PaymentType).map((it) => ({
                id: it,
                title: translate(it),
                icon: <Icon class="fas-file-alt" />,
              }))}
              isMultiselect
              value={tempFilters?.paymentMethodCode}
              onChange={({ paymentMethodCode }) => setFilters({ ...tempFilters, paymentMethodCode })}
              icon={<Icon class="fas-file-alt" />}
            />
            <InputWrapper style={{ gridColumn: 'span 2', height: 'fit-content', marginTop: 'var(--sizeM)' }}>
              <DateInput
                name="createdAtFromDateUtc"
                label={lang.createdAtFromDate}
                dateTimeFormat={defaultInputDateTimeFormat}
                value={tempFilters?.createdAtFromDateUtc}
                onChange={({ createdAtFromDateUtc }) => setFilters({ ...tempFilters, createdAtFromDateUtc })}
                icon={<Icon class="fas-calendar-alt" />}
              />
              <DateInput
                name="createdAtToDateUtc"
                label={lang.createdAtToDate}
                dateTimeFormat={defaultInputDateTimeFormat}
                value={tempFilters?.createdAtToDateUtc}
                onChange={({ createdAtToDateUtc }) => setFilters({ ...tempFilters, createdAtToDateUtc })}
                icon={<Icon class="fas-calendar-alt" />}
              />
            </InputWrapper>
          </>
        )}
      />
    </div>
  );
}
